export default "__VITE_ASSET__CHrtwrY0__"